import Couple2 from "./images/Couple2.png";
import Couple from "./images/Couple.png";
import Coeur from "./images/Coeur.png";

import Oeil from "./images/Oeil.png";
import Heloise from "./images/Heloise.jpg";
import Patern from "./images/patern.jpg";
import TSUCHIYA1 from "./images/TSUCHIYA1.jpg";

import VOISIN1 from "./images/VOISIN1.jpg";

import françoisJadeSansTitre from "./images/françoisJadeSansTitre.jpg";


import Bateau from "./images/Bateau.jpg";
import VOISINEmma2 from "./images/VOISINEmma2.jpg";
import Twosided  from "./images/Twosided.jpg";
import Iloveyou from "./images/Iloveyou.jpg";
import Redcherries from "./images/Redcherries.jpg";


const artworks = [
    { id: 1, title: "Couple2", artist: "Inconnu", category: "Dessin", image: Couple2 },
    { id: 2, title: "Couple", artist: "Inconnu", category: "Peinture toile", image: Couple },
    { id: 3, title: "Coeur", artist: "Inconnu", category: "Peinture", image: Coeur},
    { id: 4, title: "Love at first sight", artist: "FUJITA Chloé", category: "Peinture toile", image: Oeil},
    { id: 5, title: "Love at first sight", artist: "KWINTNER Célia", category: "Peinture toile", image: Oeil},
    { id: 6, title: "Héloise", artist: "BATAILLE WATANABE Nina", category: "Fusain", image: Heloise},
    { id: 7, title: "Pattern", artist: "SANCY Héloise", category: "Pastel", image: Patern},
    { id: 8, title: "en attente d’un titre", artist: "TSUCHIYA Lisa", category: "Art numérique", image: TSUCHIYA1},
    { id: 9, title: "en attente d’un titre", artist: "Voisin Emma", category: "Art numérique", image: VOISIN1},
    { id: 10, title: "en attente d’un titre", artist: "François Jade", category: "Art numérique", image: françoisJadeSansTitre},  
    { id: 11, title: "Bateau", artist: "FABRE Eulalie", category: "Peinture toile", image: Bateau},
    { id: 12, title: "en attente d’un titre", artist: "Voisin Emma", category: "Peinture toile", image: VOISINEmma2},
    { id: 13, title: "Two sided", artist: "KWINTNER Célia", category: "Peinture toile", image: Twosided},
    { id: 14, title: "I love you", artist: "KWINTNER Célia", category: "Peinture toile", image: Iloveyou},
    { id: 15, title: "Red cherries", artist: "FUJITA Chloé", category: "Peinture toile", image: Redcherries},
];

export default artworks;

